import {TestingStatus} from './TestingStatus';
import {TestRequestCreateOperation} from './TestRequestCreateOperation';

export interface TestRequest {
    serialNumber: number,
    identifier: string,
    userLogin: string,
    currentStatus: TestingStatus,
    testPurpose: string,
    requestDescription: string,
    creationDate: string,
    lastUpdatedDate: string,
}

export interface TestRequestCreateInput {
    userLogin: string,
    testPurpose: string,
    requestDescription: string,
    operation: TestRequestCreateOperation,
}

export const createInputForCopy = (input: TestRequest) => {
    return {
        userLogin: input.userLogin,
        testPurpose: input.testPurpose,
        requestDescription: input.requestDescription,
        operation: TestRequestCreateOperation.COPY,
    } as TestRequestCreateInput;
}

export const createInputForNew = (login: string, purpose: string, description: string) => {
    return {
        userLogin: login,
        testPurpose: purpose,
        requestDescription: description,
        operation: TestRequestCreateOperation.NEW,
    } as TestRequestCreateInput;
}

export const createTestRequestFromInput = (input: TestRequestCreateInput) => {
    return {
        serialNumber: -1,
        identifier: "-1",
        userLogin: input.userLogin,
        currentStatus: TestingStatus.InProgress,
        testPurpose: input.testPurpose,
        requestDescription: input.requestDescription,
        creationDate: "-1",
        lastUpdatedDate: "-1",
    } as TestRequest;
}



export const MY_TEST_ITEM_1 = {
    serialNumber: 1,  // assign by sorting after fetching from DDB
    identifier: 'abcd-ef',
    userLogin: 'dewsaket',
    currentStatus: TestingStatus.InProgress,
    testPurpose: 'IE Mkt Launch',
    requestDescription: 'Marketplace launch for IE',
    creationDate: '2024-03-25',
    lastUpdatedDate: '2024-03-25',
} as TestRequest;

export const MY_TEST_ITEM_2 = {
    serialNumber: 2,  // assign by sorting after fetching from DDB
    identifier: '12345',
    userLogin: 'dewsaket',
    currentStatus: TestingStatus.Complete,
    testPurpose: 'DA Launch',
    requestDescription: 'DA capitalization project Testing',
    creationDate: '2024-03-25',
    lastUpdatedDate: '2024-03-25',
} as TestRequest;